import React from 'react'
import { useTranslation } from 'react-i18next'
import ShowLegalAndRegTexts from '../components/LegalAndRegulatorText/ShowLegalAndRegTexts'

const LegalAndRegText = () => {
  const { t } = useTranslation()
  return (
    <div className='mt-20'>
      <h1 className='text-center text-3xl'>{t("Textes juridique et réglementaires")}</h1>
      <ShowLegalAndRegTexts />
    </div>

  )
}

export default LegalAndRegText